import React from 'react';

import {useMediaSettingsDrawerContext} from '../../MediaSettingsDrawerContextProvider';
import {BoundingBoxClasses} from './BoundingBoxClasses';

export const BoundingBoxesForMediaKey = ({
  mediaKey,
  boxQueryRegex,
}: {
  mediaKey: string;
  boxQueryRegex: RegExp;
}) => {
  const {allBoxes} = useMediaSettingsDrawerContext();
  const relevantMasks = allBoxes[mediaKey];
  return (
    <div className="pt-16">
      {Object.keys(relevantMasks).map(boxKey => {
        return (
          <BoundingBoxClasses
            boxKey={boxKey}
            mediaKey={mediaKey}
            key={`${mediaKey}-${boxKey}`}
            boxQueryRegex={boxQueryRegex}
          />
        );
      })}
    </div>
  );
};
